// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponent.layout.modal.';

const DESCRIPTION = `${DOMAIN}description`,
  TITLE = `${DOMAIN}title`;

export { DESCRIPTION, TITLE };
